import { CapaBankCode } from '@generated/graphql';

export const bankMap = (bankCode?: CapaBankCode) => {
  if (!bankCode) return '';
  switch (bankCode) {
    case CapaBankCode.KbBank:
      return 'KB국민은행';
    case CapaBankCode.ScBank:
      return 'SC제일은행';
    case CapaBankCode.KyongnamBank:
      return '경남은행';
    case CapaBankCode.KwangjuBank:
      return '광주은행';
    case CapaBankCode.Ibk:
      return '기업은행';
    case CapaBankCode.NhBank:
      return '농협';
    case CapaBankCode.DaeguBank:
      return '대구은행';
    case CapaBankCode.BusanBank:
      return '부산은행';
    case CapaBankCode.Kdb:
      return '산업은행';
    case CapaBankCode.Kfcc:
      return '새마을금고';
    case CapaBankCode.ShBank:
      return '수협';
    case CapaBankCode.ShinhanBank:
      return '신한은행';
    case CapaBankCode.CreditUnionBank:
      return '신협';
    case CapaBankCode.Keb:
      return '외환은행';
    case CapaBankCode.WooriBank:
      return '우리은행';
    case CapaBankCode.PostBank:
      return '우체국';
    case CapaBankCode.JeonbukBank:
      return '전북';
    case CapaBankCode.KakaoBank:
      return '카카오뱅크';
    case CapaBankCode.KBank:
      return '케이뱅크';
    case CapaBankCode.TossBank:
      return '토스뱅크';
    case CapaBankCode.HanaSeoulBank:
      return '하나은행_서울은행';
    case CapaBankCode.CityHanmiBank:
      return '한국씨티은행_한미은행';
  }
};
